import { useQuery } from "@tanstack/react-query"
import { getCommSummaryTotals } from "../services/query_service"

export const useCommSummaryTotalsQuery = () => {
    return useQuery({
        queryKey: ['comm-summary', 'totals'],
        queryFn: async () => getCommSummaryTotals(),
        staleTime: 1000 * 60, // 1 minute
    })
}